import { Component, h, Prop } from '@stencil/core';
import dayjs from 'dayjs';
import { IDatePartModel } from '../../models/date-part.model';

@Component({
  tag: 'pnk-date-month-selector',
  styleUrl: 'pnk-date-month-selector.css',
})
export class PnkDateMonthSelector {
  @Prop() show: boolean = false;

  @Prop() mode: string = 'd';

  @Prop() date: Date = new Date();

  @Prop() dataSource: IDatePartModel[] = [];

  @Prop() dateChange!: (date: Date) => void;

  render() {
    return (
      <div class="pnk-absolute">
        {this.show && (
          <div class="pnk-w-[262px] pnk-h-[130px] pnk-bg-disabled-base pnk-text-black pnk-text-base pnk-grid pnk-grid-cols-3 pnk-rounded pnk-p-[5px]">
            {[
              ...this.dataSource.map((item: IDatePartModel) => (
                <span
                  class=" pnk-justify-center pnk-items-center pnk-w-[84px] pnk-h-[30px] pnk-flex pnk-cursor-pointer hover:pnk-bg-primary-base hover:pnk-text-white hover:pnk-rounded"
                  onClick={() => this.setValue(item)}
                >
                  {item.name}
                </span>
              )),
            ]}
          </div>
        )}
      </div>
    );
  }

  private setValue(item: IDatePartModel): void {
    let _mode: dayjs.UnitType = 'year';
    switch (this.mode) {
      case 'd':
        _mode = 'date';
        break;
      case 'm':
        _mode = 'month';
        break;
      default:
        _mode = 'year';
        break;
    }
    const newDate: Date = dayjs(this.date).set(_mode, item.value).clone().toDate();
    this.dateChange(newDate);
  }
}
